export default {
    LAUNCH_RESEARCH({commit}, payload) {
        commit('LAUNCH_RESEARCH', payload)
    },
    SELECT({commit}, payload) {
        commit('SELECT', payload)
    },
    RESET_STATE({commit}, payload) {
        commit('RESET_STATE', payload)
    },
};